module.exports = __webpack_public_path__ + "img/5_11.81bc57b8.png";